import React, { useRef } from "react";
import PropTypes from "prop-types";
import { propOr, pathEq, reject } from "ramda";
import DragDropMaterial from "./DragDropMaterial";

import { useDrop } from "react-dnd";
import { MATERIAL_ITEM_TYPE } from "~/constants/dnd-types";

import { styled } from "@mui/material/styles";

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. ArrowFunctionExpression in CSS prop.

const Layer = styled("div")(props => {
  return {
    height: `calc(100% - ${props.marginalLayerHeight}px)`,
    width: "100%",
    position: "relative"
  };
});

function PageLayerMaterials({ materials, page, marginalLayerHeight, onMaterialDrop, onMaterialClick }) {
  // console.log(materials);
  // const formatted = materials["3"].map(
  //   material => `${material._id.substr(-4)}_${material._rev.substr(0, 4)`
  // );
  // console.log(formatted);

  const ref = useRef(null);
  const [{}, dropTarget] = useDrop({
    accept: [MATERIAL_ITEM_TYPE],
    drop: (item, monitor) => {
      if (ref.current) {
        const boundingRect = ref.current.getBoundingClientRect();
        const offset = monitor.getClientOffset();

        onMaterialDrop(item, {
          difference: monitor.getDifferenceFromInitialOffset(),
          absolute: {
            x: offset.x - boundingRect.x,
            y: offset.y - boundingRect.y
          }
        });
      }
    }
  });

  const getMaterialsByPage = propOr([], page, materials);
  const isMarginalMaterial = pathEq(["position", "marginal"], true);
  const filtered = reject(isMarginalMaterial, getMaterialsByPage);

  function renderMaterial(material) {
    if (material.noMarker) return null;
    return (
      <DragDropMaterial
        key={`dnd_material_${material._id}_${material._rev}_${material.position._id}`}
        _id={material._id}
        _rev={material._rev}
        position={material.position}
        tooltip={material.title}
        materialType={material.materialType}
        clickHandler={onMaterialClick(material)}
      />
    );
  }

  dropTarget(ref);

  return (
    <Layer ref={ref} marginalLayerHeight={marginalLayerHeight}>
      {filtered.map(renderMaterial)}
    </Layer>
  );
}

PageLayerMaterials.propTypes = {
  page: PropTypes.number.isRequired,
  materials: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  marginalLayerHeight: PropTypes.number.isRequired,
  onMaterialDrop: PropTypes.func.isRequired,
  onMaterialClick: PropTypes.func.isRequired
};

export default PageLayerMaterials;
